import { Command, Editor } from "ckeditor5";
// @ts-ignore
import AiResponseTransformationModel from "./aiResponseTransformationModel";
// @ts-ignore
import Messenger from "messaging/messenger";
// @ts-ignore
import i18next from "i18n/i18n";
import {
  getSelectedOrAllText,
  replaceText,
  removeFormattingConfirmation,
} from "./responseTransformationPluginUtil";

export default class ResponseTransformationCommand extends Command {
  private readonly operation: string;

  constructor(editor: Editor, operation: string) {
    super(editor);
    this.operation = operation;
  }

  async execute(): Promise<void> {
    const confirmed = await removeFormattingConfirmation();
    if (!confirmed) return;

    const editor = this.editor;
    const localeId = editor.config.get("languageId");
    const { text, isSelection } = getSelectedOrAllText(editor);
    if (!text || !text.trim()) {
      return;
    }

    this.isEnabled = false;
    Messenger.vent.trigger("show:saving:display");

    try {
      const model = new AiResponseTransformationModel.responseTransformation({
        isHtml: !isSelection,
        targetLocaleId: localeId,
        operation: this.operation,
        responseText: text,
      });

      await model.saveModelPromise();
      const transformedText = model.get("responseText");
      if (transformedText) {
        replaceText(editor, transformedText, isSelection);
      }
    } catch (xhr) {
      console.error("Text transformation failed", xhr);
      Messenger.okDialog(i18next.t("ai.error.transformTextError"));
    } finally {
      Messenger.vent.trigger("close:saving:display");
      this.isEnabled = true;
    }
  }
}
